/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useRef as e,useEffect as t}from"react";import{useEvent as n}from"./use-event.js";let r=Symbol();function o(e,t=!0){return Object.assign(e,{[r]:t})}function u(...o){let u=e(o);t((()=>{u.current=o}),[o]);let l=n((e=>{for(let t of u.current)null!=t&&("function"==typeof t?t(e):t.current=e)}));return o.every((e=>null==e||(null==e?void 0:e[r])))?void 0:l}export{o as optionalRef,u as useSyncRefs};
//# sourceMappingURL=use-sync-refs.js.map
